import { forwardRef } from "react";

import { useTranslations } from "next-intl";

import { twMerge } from "@/utils/twMerge";

import type { ComponentProps } from "react";

export const RemovePermissionButton = forwardRef<
  HTMLButtonElement,
  ComponentProps<"button"> & { onClick: () => void }
>(({ onClick, ...props }, ref) => {
  const t = useTranslations();

  return (
    <div className="flex flex-col">
      <div className="h-[1px] mt-1.5 mb-1.5 mx-1.25 bg-gray-200 dark:bg-gray-800" />
      <button
        {...props}
        ref={ref}
        type="button"
        aria-label={t("share.remove")}
        onClick={onClick}
        className={twMerge(
          "w-full min-h-8.5 py-1.25 px-2.5 text-sm flex items-center rounded-8 whitespace-nowrap tracking-tight text-red-500",
          "sm:text-[16px]",
          "data-[focus]:bg-sidebar-button-active-bg",
        )}
      >
        {t("share.remove")}
      </button>
    </div>
  );
});
